import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { VendorAdminService } from "../../../services/api/vendor-admin.service";
import { VendorAdminActions } from "../../actions/vendor-admin.actions";
import { FailState } from "../../models/fail-state";

@Injectable()
export class VendorUserCreateEffects {
	create = createEffect(() =>
		this.actions.pipe(
			ofType(VendorAdminActions.user.create),
			switchMap((action) =>
				this.vendorAdminService.inviteUser(action.request).pipe(
					map(() => VendorAdminActions.user.createSuccess()),
					catchError((error) =>
						of(VendorAdminActions.user.createFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private vendorAdminService: VendorAdminService
	) {}
}
